import React from 'react';
import { Box, Divider } from '@mui/material';

import Hidden from '../../Hidden';

export default function ResponsiveDivider() {
  return (
    <Hidden breakpoint="sm" direction="down">
      <Box sx={{ mr: 2, mb: 2 }}>
        <Divider orientation="vertical" />
      </Box>
    </Hidden>
  );
}
